import type { Variant } from '@storefront/lib-global/codegen/types';

export const areAllVariantsWithNotificationsDisabled = (variants: Variant[]): boolean =>
  variants.every((variant) => !variant.backInStockNotificationsEnabled);
